import { InventoryImport } from './Import'
const { RoutesMap, InwardList, StockAvailabilityList, PricingList, OutwardList } = InventoryImport

const InventoryRoute = () => {
    return [
        {
            path: RoutesMap.INWARD_LIST.path,
            element: <InwardList />
        },
        {
            path: RoutesMap.STOCK_AVAILABILITY_LIST.path,
            element: <StockAvailabilityList />
        },
        {
            path: RoutesMap.PRICING_LIST.path,
            element: <PricingList />
        },
        {
            path: RoutesMap.OUTWARD_LIST.path,
            element: <OutwardList />
        },
    ]
}

export default InventoryRoute;